import { NavLink } from "react-router-dom";

// Package Imports
import { v4 as uuidv4 } from "uuid";

// Material UI Imports
import { Divider, Menu, MenuItem } from "@mui/material";

type PropsType = {
  label: string;
  items: {
    name: string;
    link: string;
  }[];
  anchorEl: HTMLElement | null;
  open: boolean;
  handleClick: (
    event: React.MouseEvent<HTMLLIElement | HTMLDivElement, MouseEvent>
  ) => void;
};

const SideNavbarMenu = ({
  label,
  items,
  anchorEl,
  open,
  handleClick,
}: PropsType) => {
  return (
    <Menu
      className="side-navbar-menu"
      anchorEl={anchorEl}
      open={open}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <p className="side-navbar-menu-label pulse-typography-body-1 pulse-color--background-100">
        {label}
      </p>
      <Divider className="side-navbar-menu-divider" />
      {items.map((item) => (
        <NavLink
          key={uuidv4()}
          to={item.link}
          className={({ isActive }: { isActive: boolean }) =>
            `side-navbar-menu-item-link pulse-color--background-100 ${isActive ? "isActive" : ""
            }`
          }
        >
          <MenuItem key={item.name} onClick={handleClick} >
            <p className="pulse-typography-body-2 pulse-color--background-100">
              {item.name}
            </p>
          </MenuItem>
        </NavLink>
      ))}
    </Menu>
  );
};

export default SideNavbarMenu;
